import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { IStudent } from '../../../../models/students/i-student';
import { ReportService } from '../../../../services/reports/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolYearService } from '../../../../services/schoool-year/school-year.service';
import { SchoolYear } from '../../../../models/school-years/school-year';

@Component({
    selector: 'fuse-management-school-year',
    templateUrl: './schoolyear.component.html',
    styleUrls: ['./schoolyear.component.scss'],
    animations: fuseAnimations
})
export class SchoolyearComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Year', 'StartDate', 'FinishDate', 'State', 'Actions'];
    schoolYearDatabase: SchoolYearDatabase;
    dataSource: SchoolYearDataSource | null;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private schoolYearService: SchoolYearService,
        private reportService: ReportService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        this.schoolYearDatabase = new SchoolYearDatabase(this.schoolYearService);
        this.dataSource = new SchoolYearDataSource(this.schoolYearDatabase, this.paginator, this.sort);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        this.blockUI.stop();
    }

    ngOnDestroy() {

    }

    add() {
        this.router.navigate(['pages/management/schoolyear/add']);
    }

    edit(schoolYear: any) {
        this.router.navigate(['pages/management/schoolyear/edit/' + schoolYear.Id]);
    }

    view(schoolYear: any) {
        this.router.navigate(['pages/management/schoolyear/view/' + schoolYear.Id]);
    }

    delete(student: IStudent) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', student.LastName + ' ' + student.FirstName, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                // this.schoolYearService.delete(student.Id).subscribe(response => {
                //     if (response.resultCode == 1) {
                //         this.studentDatabase.delete(student);
                //         const index = this.studentService.students.findIndex(s => s.Id == student.Id);
                //         if (index >= 0) {
                //             this.studentService.students.splice(index, 1);
                //             delete this.studentService.studentObject[student.Id];
                //         }
                //         this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                //     } else {
                //         this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                //             this.sweetAlertService.error('Error', res, null);
                //         });
                //     }
                // }, error => {
                //     this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                //         this.sweetAlertService.error('Error', res, null);
                //     });
                // });
            }, () => {
                console.log('FuseStudentComponent > delete > canceled');
            });
        });
    }

    setCurrent(schoolYear: any) {
        console.log('schoolYear', schoolYear);

        // this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', '', (res) => {
        this.sweetAlertService.question(this.translationService.confirmation, '¿Establecer como activo?', this.translationService.yes, this.translationService.no, () => {
            this.blockUI.start(this.translationService.loading);
            this.schoolYearService.setCurrent(schoolYear.Id).subscribe(response => {
                if (response) {
                    console.log(response);
                    const authData = this.authenticationService.getAuthData();
                    authData.SchoolYear = response;
                    this.authenticationService.setAuthData(authData);
                    window.location.reload();
                }
                this.blockUI.stop();
            });
        }, () => {
            console.log('FuseStudentComponent > delete > canceled');
            this.blockUI.stop();
        });
        // });
    }

    setCurrentInscription(schoolYear: any) {
        console.log('schoolYears', schoolYear);
        // this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', '', (res) => {
        this.sweetAlertService.question(this.translationService.confirmation, '¿Establecer como Periodo de Inscripción?', this.translationService.yes, this.translationService.no, () => {
            this.blockUI.start(this.translationService.loading);
            this.schoolYearService.setCurrentInscription(schoolYear.Id).subscribe(response => {
                if (response) {
                    console.log(response);
                    schoolYear = response;
                    this.schoolYearDatabase.edit(schoolYear);
                }
                this.blockUI.stop();
            });
        }, () => {
            console.log('FuseStudentComponent > delete > canceled');
            this.blockUI.stop();
        });
        // });
    }
}

export class SchoolYearDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<SchoolYear[]> = new BehaviorSubject<SchoolYear[]>([]);

    get data(): SchoolYear[] {
        return this.dataChange.value;
    }

    constructor(
        private schoolYearService: SchoolYearService,
    ) {
        setTimeout(() => {
            this.schoolYearService.getAll().subscribe(response => {
                console.log('SchoolYearComponent > response', response);
                for (const r of response) {
                    this.add(r);
                }
            }, error => {

            });
        }, 100);
    }

    public add(store: SchoolYear) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: SchoolYear) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: SchoolYear) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, StoreDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class SchoolYearDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    filteredData: SchoolYear[] = [];
    renderedData: SchoolYear[] = [];
    dataLength = 0;

    constructor(
        private _schoolYearDatabase: SchoolYearDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort
    ) {
        super();
        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<SchoolYear[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._schoolYearDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._schoolYearDatabase.data.slice().filter((item: SchoolYear) => {
                const searchStr = (item.Description).toLowerCase();
                return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._schoolYearDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: SchoolYear[]): SchoolYear[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'LastName':
                    [propertyA, propertyB] = [a.Description, b.Description];
                    break;
                // case '':
                //     [propertyA, propertyB] = [a.description, b.description];
                //     break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/schoolyear.component.ts